module.exports = __webpack_public_path__ + "img/tickets-r3-remote-assistance.e335e0c5.png";